import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {logger} from "@retail-data-factory/rdf-angular-utils";
import {DataService} from "./data.service";
import {Presenter} from "../../api/internal/presenter/presenter";
import {ConfigurationManager} from "../../store/configuration-manager/configuration-manager";
type typeOptions = 'ERROR' | 'INFO';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor( private http: HttpClient, private dataService: DataService, public presenter: Presenter, private configurationManager: ConfigurationManager) {

  }
  log(method: string, stage: string, parameters: object, description:string, message: string, type: typeOptions, code: string, execTime: string){

    parameters = parameters?parameters:{};
    parameters['date']=Date.now().toString();

    const headers = new HttpHeaders();

    const body ={
      "UID": this.presenter.accessToken,
      "Service": "front_app",
      "Version": this.dataService.appVersion,
      "Date": Date.now().toString(),
      "Method": method,
      "Stage": stage,
      "Login": `partyId='${this.presenter.currentPartyId}', login='${this.presenter.login}'`,
      "RequestParameters": JSON.stringify(parameters),
      "SQL": description,
      "Type": type,
      "ExecTime": execTime,
      "Message": message,
      "Code": code
    };
    try {
      this.http.post(this.configurationManager.getApiUrl('apiLogUrl') + '/log',
        body, {headers: headers}).subscribe(() =>{

      });

    }catch (e) {
      logger.print('Post log to server failed with error '+e,'error');
    }
  }
}
